import { Alert } from 'antd';
import styled, { css } from 'styled-components';

const StyledAlert = styled(Alert)`
  text-align: center;
  margin-bottom: 15px;
  ${(props) =>
    props.type === 'error' &&
    css`
      background: ${props.theme.colorErrorBg};
      border-color: ${props.theme.colorError};
      .ant-alert-message {
        color: #fff;
      }
    `};
  ${(props) =>
    props.type === 'success' &&
    css`
      background: ${props.theme.colorSuccessBg};
      border-color: ${props.theme.colorSuccess};
      .ant-alert-message {
        color: #fff;
      }
    `};
  ${(props) =>
    props.type === 'warning' &&
    css`
      background: ${props.theme.colorWarningBg};
      border-color: ${props.theme.colorWarning};
      .ant-alert-message {
        color: #fff;
      }
    `};
`;

export const ErrorAlert = styled(Alert)`
  text-align: center;
`;

export default StyledAlert;
